import React from "react";
import env from "config/env";
import { useAppSelector } from "./useAppSelector";
import { AccountTicketDetails } from "features/types";

const useResolveNativeUrl = (params: {
  path: string;
  accountEvent: AccountTicketDetails;
  transferCode: string;
}) => {
  const { path, accountEvent, transferCode } = params;
  const tenantSubdomain = useAppSelector(
    (state) => state.tenant.tenantSubdomain
  );

  const resolveNativeUrl = () => {
    const base = env.rootUrl.replace("tenantSubdomain", tenantSubdomain!);
    return `${base}/${path}/${accountEvent!.event.code}/${transferCode}`;
  };

  return resolveNativeUrl();
};

export default useResolveNativeUrl;
